import { init } from './init';

export type {
  ConsentPolicy,
  PolicyDetails,
  ConsentPolicyManagerInterface,
} from './types';

init();
